export const FOCUSABLE_SELECTORS =
  'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

export const HANDLE_TESTID = 'bottom-sheet-handle';
export const CLOSE_BUTTON_TESTID = 'bottom-sheet-close';

/** Snap points expressed as fractions of the viewport height. */
export const DEFAULT_SNAP_POINTS = [0.3, 0.6, 0.9] as const;
/** Index into DEFAULT_SNAP_POINTS used as the initial resting height. */
export const DEFAULT_INITIAL_SNAP_INDEX = 1;
/** Hard ceiling on panel height — never drag past this fraction of viewport. */
export const DEFAULT_MAX_HEIGHT_PCT = 0.92;
/** Floor on live drag height in px, before the close-threshold logic kicks in. */
export const DEFAULT_MIN_HEIGHT_PX = 80;
/** Fallback used when snapPoints is empty or an index resolves to undefined. */
export const FALLBACK_SNAP_PCT = 0.6;
